import React, { useState } from "react";
import { FaMinus, FaPlus, FaShieldAlt,FaClipboardList,FaExclamationTriangle, FaUserMd, FaFileMedical, FaChartLine, FaVials, FaCapsules, FaMicroscope, FaNotesMedical } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/parmamedi.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Adverse Event Reporting",
        "description": "Systematic collection, documentation, and real-time analysis of adverse drug reactions (ADRs) to enhance patient safety. This includes AI-driven signal detection, spontaneous reporting systems, healthcare professional notifications, and patient feedback. Advanced analytics help identify potential safety concerns early, improving regulatory decision-making and risk assessment."
    },
    {
        "title": "Risk Management & Mitigation",
        "description": "Implementing proactive risk minimization strategies to prevent, assess, and mitigate potential drug-related hazards. This involves benefit-risk evaluations, targeted safety monitoring, dosage adjustments, black box warnings, patient education programs, and regulatory interventions to optimize drug safety and therapeutic efficacy."
    },
    {
        "title": "Post-Marketing Surveillance",
        "description": "Ongoing real-world monitoring of pharmaceuticals post-approval to assess long-term safety, effectiveness, and rare adverse reactions. This includes observational studies, electronic health record (EHR) data analysis, patient registries, big data-driven pharmacovigilance, and predictive modeling to enhance drug safety assessments."
    },
    {
        "title": "Regulatory Compliance & Reporting",
        "description": "Ensuring adherence to global pharmacovigilance regulations, including FDA, EMA, WHO, and ICH guidelines. This involves timely submission of periodic safety update reports (PSURs), individual case safety reports (ICSRs), risk management plans (RMPs), and compliance with Good Pharmacovigilance Practices (GVP) to maintain high safety and regulatory standards."
    },
    {
        "title": "Clinical Safety Data Analysis",
        "description": "Advanced evaluation of clinical trial safety data using AI and biostatistics to identify safety signals, emerging risks, and potential adverse reactions. Real-time data monitoring, predictive analytics, and machine learning applications help refine drug development, inform regulatory labeling, and enhance patient safety measures."
    },
    {
        "title": "Pharmacovigilance Audits",
        "description": "Conducting comprehensive internal and external audits to assess compliance with Good Pharmacovigilance Practices (GVP). These audits evaluate data integrity, regulatory adherence, and the effectiveness of safety monitoring systems. AI-driven audit automation and risk-based audit strategies enhance pharmacovigilance quality assurance and transparency."
    }
]

const features = [
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Continuous monitoring of drug safety through real-world data analysis." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Adverse event reporting systems for quick identification of risks." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Risk management planning to minimize drug-related complications." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Post-marketing surveillance for ongoing safety evaluation." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Compliance with international regulatory requirements for global drug approval." }
];
const benefits = [
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Enhances drug safety and minimizes adverse reactions." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Protects public health by identifying and mitigating drug risks." },
    { icon: <FaExclamationTriangle className="text-[#2a627a] text-lg" />, text: "Improves patient trust with stringent safety monitoring." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Ensures compliance with global health regulations." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Reduces liability risks for pharmaceutical companies." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Supports evidence-based improvements in drug formulations." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        title: "Pharmacovigilance Specialist",
        text: "Monitors and assesses adverse drug reactions to ensure patient safety."
    },
    {
        icon: <FaExclamationTriangle className="text-[#2a627a] text-lg" />,
        title: "Drug Safety Officer",
        text: "Investigates safety concerns and ensures compliance with regulatory requirements."
    },
    {
        icon: <FaClipboardList className="text-[#2a627a] text-lg" />,
        title: "Clinical Safety Scientist",
        text: "Analyzes clinical trial safety data to identify potential risks and ensure efficacy."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,
        title: "Regulatory Compliance Manager",
        text: "Ensures pharmacovigilance activities align with FDA, EMA, and global safety standards."
    }
];
const PharmacovigilanceDrugSafety = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex"> Pharmacovigilance & Drug Safety - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Ensuring patient safety by continuously monitoring, detecting, and managing adverse drug reactions to optimize therapeutic outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Pharmacovigilance & Drug Safety?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Pharmacovigilance focuses on monitoring, assessing, and preventing adverse effects of pharmaceutical products
                            to ensure drug safety. At HIKEHEALTH GS, we implement robust surveillance systems, real-time data analysis, and
                            regulatory compliance measures to detect, report, and mitigate risks associated with medications. Our commitment
                            to drug safety helps protect patients and enhances public health by ensuring the continuous monitoring of
                            pharmaceutical products throughout their lifecycle.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Pharmacovigilance & Drug Safety
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PharmacovigilanceDrugSafety;
